import { connect } from 'react-redux'
import {
  compose, lifecycle, withHandlers, withState,
} from 'recompose'
import { bindActionCreators } from 'redux'
import { webSocialMediaList } from 'actions/Layout'
import { fetchWebMenu } from 'actions/Menu'
import { withRouter } from 'react-router-dom'
import PublicLayoutView from 'components/layouts/PublicLayout'
import { ShootTracker } from 'actions/Tracker'

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({
  webSocialMediaList: bindActionCreators(webSocialMediaList, dispatch),
  fetchWebMenu: bindActionCreators(fetchWebMenu, dispatch),
  ShootTracker: bindActionCreators(ShootTracker, dispatch),
})

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('socmedData', 'setSocmedData', {
    isFetching: true,
    list: [],
  }),
  withState('menuList', 'setMenuList', {
    isFetching: true,
    list: [],
  }),
  withState('footerButtonTracker', 'setFooterButtonTracker', {}),
  withHandlers({
    clickFooterButton: (props) => async (botton_name, button_url) => {
      const { setFooterButtonTracker } = props
      try {
        const res = await props.ShootTracker(
          'click_footer_button',
          {
            key: 'button_name',
            value: botton_name
          },
          {
            key: 'button_url',
            value: button_url
          },
        )
        setFooterButtonTracker(res)
      } catch (err) {
        setFooterButtonTracker({})
      }
    },
  }),
  withHandlers({
    getList: props => async (params) => {
      const { setSocmedData } = props
      try {
        const res = await props.webSocialMediaList(params)
        setSocmedData({
          isFetching: false,
          list: res,
        })
      } catch (err) {
        setSocmedData({
          isFetching: false,
          list: [],
        })
      }
    },
    getMenuList: props => async (params) => {
      const { setMenuList } = props
      try {
        const res = await props.fetchWebMenu(params)
        setMenuList({
          isFetching: false,
          list: res,
        })
      } catch (err) {
        setMenuList({
          isFetching: false,
          list: [],
        })
      }
    },
  }),
  lifecycle({}),
)(PublicLayoutView)
